// Access- und Refresh-Token je Kontext ("user" / "club") unter eigenem localStorage-Schlüssel.
// Bewusst nicht im Vuex-Stand: vuex-persistedstate schreibt bei jeder Mutation den ganzen
// Stand des Tabs zurück und würde so den frisch getauschten Token eines anderen Tabs
// mit einem alten überschreiben. Das Backend wertet einen alten Refresh-Token als Diebstahl
// und meldet dann alle Sitzungen ab.

const KEYS = { user: "auth_user", club: "auth_club" };

export function getTokens(context) {
  try {
    return JSON.parse(localStorage.getItem(KEYS[context])) || {};
  } catch (e) {
    return {};
  }
}

export function setTokens(context, accessToken, refreshToken) {
  try {
    localStorage.setItem(KEYS[context], JSON.stringify({
      access_token: accessToken,
      refresh_token: refreshToken || null
    }));
  } catch (e) {
    // localStorage nicht verfügbar – nach Ablauf wird wie früher neu angemeldet
  }
}

export function clearTokens(context) {
  try {
    localStorage.removeItem(KEYS[context]);
  } catch (e) {
    // localStorage nicht verfügbar
  }
}
